import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Button from 'material-ui/Button';
import classNames from 'classnames';
import ItemTitle from "../parts/ItemTitle";
import ItemDetails from "../parts/ItemDetails";
import DownloadButtons from "../parts/DownloadButtons";
import SalesforceSync from "../parts/SalesforceSync";
import { connect } from 'react-redux';
import { ORDER_TYPES } from "../../../constants/OrderValues";

const styles = () => ({
  root: {
    padding: 20,
    borderBottom: '1px solid #00000026',
    display: "flex",
    justifyContent: 'space-between',
  },

  right: {
    display: "flex",
    fontSize: 13,
    marginLeft: 20,
    alignItems: 'center',
  },

  btn: {
    padding: '10px 18px',
    height: "33px",
    minWidth: "62px",
    borderRadius: "2px",
    fontSize: "13px",
    textTransform: 'none',
    whiteSpace: 'nowrap',
  },

  btnEnable: {
    border: "1px solid #1A65FF",
    background: "#FFFFFF",
    color: "#1A65FF",
    "&:hover": {
      background: "#1A65FF",
      color: '#FFFFFF',
    },
  },
});

class OrderItem extends React.Component {
  render() {
    const { classes, item, user, key } = this.props;
    const isOrderedLetter = item.letter_order ? true : false;
    const isOrderFollowCall = item.follow_call_order ? true : false;
    const isOrderProcessDone = isOrderedLetter ? item.letter_order.latest_order_address : item.follow_call_order.latest_order_address;

    return (
      <div className={classes.root} key={key}>
        <div className={classes.left}>
          {/* 注文タイトルを表示 */}
          <ItemTitle
            item={item}
          />
          {/* 注文詳細情報を表示 */}
          <ItemDetails
            item={item}
            callFontColor={'#195AFF'}
            callBackground={'#F2F6FF'}
          />
        </div>
        <div className={classes.right}>
          {/* DLリンクなどを表示 */}
          {!!isOrderedLetter && (
            <DownloadButtons item={item.letter_order} />
          )}

          {/* レター注文のSalesforce関連を表示 */}
          {!!isOrderedLetter && !!isOrderProcessDone && user && !!user.salesforce_integration_flag && (
            <SalesforceSync
              item={item.letter_order}
              type={ORDER_TYPES.LETTER}
              displayNotification={this.props.displayNotification}
            />
          )}

          {/* フォローコール注文のSalesforce関連を表示 */}
          {!!isOrderFollowCall && !!isOrderProcessDone && user && !!user.salesforce_integration_flag && (
            <SalesforceSync
              item={item.follow_call_order}
              type={ORDER_TYPES.FOLLOW_CALL}
              displayNotification={this.props.displayNotification}
            />
          )}

          {/* 詳細ボタンを表示 */}
          {!!isOrderProcessDone && (
            <Button className={classNames(classes.btn, classes.btnEnable)}
              onClick={() => {
                this.props.goTo(
                  `/orders/${item.id}`, { ownerType: this.props.ownerType, selectedYear: this.props.selectedYear, selectedMonth: this.props.selectedMonth }
                )
              }}
            >
              詳細
            </Button>
          )}
        </div>
      </div>
    );
  }
}

OrderItem.propTypes = {
  classes: PropTypes.object.isRequired,
  item: PropTypes.object.isRequired,
  goTo: PropTypes.func.isRequired,
  displayNotification: PropTypes.func,
  ownerType: PropTypes.string.isRequired,
  selectedYear: PropTypes.string,
  selectedMonth: PropTypes.string,
  user: PropTypes.object,
  key: PropTypes.number,
};

const mapStateToProps = (state) => {
  return {
    user: state.accountSetting.user,
  };
};

export default withStyles(styles)(connect(
  mapStateToProps
)(OrderItem));



// WEBPACK FOOTER //
// ./src/components/OrderList/items/OrderItem.jsx